<template>
  <div id="mb-custom-coding">
    <div
      class="mb-custom-coding-scalable"
      :style="{
        transform: 'translate(-50%, -50%) scale(' + scale + ')',
      }"
    >
      <div class="local-coding-select" v-if="localDbData && !showCoding">
        <div
          :value="itm"
          class="local-coding-select-item"
          @click="
            select = itm;
            getLocalRoulette(itm.id);
          "
          v-for="(itm, index) in localDbData.rows"
          :key="'coding-local-' + index"
        >
          {{ itm.id }}
        </div>
      </div>
      <div
        v-if="showCoding && showConfig"
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: 0.3s;
          background: rgba(0, 0, 0, 0.3);
          z-index: 5;
        "
      ></div>
      <div
        class="element-adder"
        style="position: absolute; top: 10px; z-index: 5; transition: 0.5s"
        :style="[showConfig ? { top: '100px' } : { top: '900px' }]"
      >
        <p v-if="!showConfig" @click="showConfig = true">otwórz konfiguracje</p>
        <p>Stwórz mate do kodowania!</p>
        <div class="element-adder-item">
          <div class="left">
            <span>ilość wierszy:</span>
          </div>
          <div class="right">
            <span
              v-for="(itm, index) in 10"
              :key="'custome-coding-items-rows-' + index"
              :style="[rowsNumber == itm + 1 ? { color: 'black' } : { color: 'gray' }]"
              @click="
                rowsNumber = itm + 1;
                createTable(columnsNumber, rowsNumber, colorsNumber);
              "
              v-html="itm + 1 + ' '"
            ></span>
          </div>
        </div>
        <div class="element-adder-item">
          <div class="left">
            <span>ilość kolumn:</span>
          </div>
          <div class="right">
            <span
              v-for="(itm, index) in 10"
              :key="'custome-coding-items-columns-' + index"
              :style="[columnsNumber == itm + 1 ? { color: 'black' } : { color: 'gray' }]"
              @click="
                columnsNumber = itm + 1;
                createTable(columnsNumber, rowsNumber, colorsNumber);
              "
              v-html="itm + 1 + ' '"
            ></span>
          </div>
        </div>
        <div class="element-adder-item">
          <div class="left">
            <span>kolor:</span>
          </div>
          <div class="right-flex">
            <div
              v-for="(itm, index) in colors"
              :key="'custome-coding-items-colors-' + index"
              style="width: 30px; height: 30px; display: inline-block; margin: 0 5px"
              :style="[actualColor.color == itm ? { opacity: '1' } : { opacity: '.5' }, { background: itm }]"
              @click="
                actualColor.color = itm;
                actualColor.id = index + 1;
              "
            ></div>
          </div>
        </div>
        <div class="element-adder-item icon-container">
          <!-- <img draggable="false" v-if="!showCoding" @click="addElement()" :src="addIcon" style="padding: 10px" /> -->
          <img draggable="false" @click="codingShow()" :src="addIcon" style="padding: 10px" />
          <button @click="clearLocalRoulette()">CLEAR DB</button>
          <button @click="addCustomRouletteToLocalDb()">DODAJ DO DB</button>
        </div>
      </div>
      <div
        class="icon-container-small"
        style="z-index: 5"
        @mouseenter="exitIconHover = true"
        @mouseleave="exitIconHover = false"
      >
        <img draggable="false" class="exit-icon controll-icon-small" @click="closeModal()" :src="exitIcon" />
        <transition name="icon-fade">
          <img
            draggable="false"
            v-if="exitIconHover"
            class="controll-icon-small"
            @click="closeModal()"
            :src="exitIconOn"
          />
        </transition>
      </div>
      <transition name="modal-fade">
        <div class="main-container" v-if="customCoding.table.length > 1 && !showCoding">
          <div class="table-container">
            <div class="row" v-if="!customCoding.withoutKey">
              <div
                class="row-number"
                v-for="(num, numId) in customCoding.table[0].length + 1"
                :key="'mb-coding-num-row-' + numId"
                v-html="letAlphabet(numId)"
                :style="{
                  width: setValue(customCoding.width, 100) + 'px',
                  height: setValue(customCoding.height, 100) + 'px',
                }"
              ></div>
            </div>
            <div class="row" v-for="(row, rowId) in customCoding.table" :key="'mb-coding-row-' + rowId">
              <div
                v-if="!customCoding.withoutKey"
                class="row-number"
                :style="{
                  width: setValue(customCoding.width, 100) + 'px',
                  height: setValue(customCoding.height, 100) + 'px',
                }"
              >
                {{ rowId + 1 }}
              </div>
              <div
                class="row-item"
                v-for="(it, itId) in row"
                :key="'mb-coding-row-item-' + itId"
                @click="setColor(rowId, itId, it.block)"
                :style="[
                  {
                    background: it.actualColor,
                    width: setValue(customCoding.width, 100) + 'px',
                    height: setValue(customCoding.height, 100) + 'px',
                  },
                  it.block ? { cursor: 'auto' } : {},
                ]"
              >
                <transition name="img-fade">
                  <img v-if="it.src" :src="it.src" />
                </transition>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- <transition name="modal-fade">
        <div
          v-if="showCoding"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        >
          <mb-coding :start-game-config="customCoding"></mb-coding>
        </div>
      </transition>-->
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
// import MbCoding from '../MbCoding';
import PouchDB from 'pouchdb-browser';
export default {
  name: 'mb-custom-coding',
  // components: { MbCoding },
  data: function () {
    return {
      actualColor: { color: 'white', id: 0 },
      exitIconHover: false,
      select: null,
      columnsNumber: null,
      colorsNumber: null,
      rowsNumber: null,
      scaleW: 1,
      showCoding: false,
      scaleH: 1,
      scale: 1,
      localDB: null,
      showConfig: true,
      localDbData: null,
      customCoding: {
        width: 80,
        height: 80,
        table: [],
        colors: [],
      },
      colors: ['#3cb44b', '#ffe119', '#4363d8', '#911eb4', '#42d4f4'],
    };
  },
  mounted() {
    this.scaleW = this.setWidthScale();
    this.scaleH = this.setHeightScale();
    this.resizeWindow();
    this.initDb();
  },
  methods: {
    setColor(rowId, itId, block) {
      if (!block) {
        if (this.actualColor.color != '') {
          this.customCoding.table[rowId][itId].actualColor = this.actualColor.color;
          // this.customCoding.table[rowId][itId].color = this.actualColor.id;
          if (this.actualColor.src) {
            this.customCoding.table[rowId][itId].src = this.giveMeImagePlease(this.actualColor.src);
          } else {
            this.customCoding.table[rowId][itId].src = null;
          }
        }
      }
    },
    setValue(value, defaultVal) {
      return value ? value : defaultVal;
    },
    letAlphabet(num) {
      if (num != 0) {
        return '' + String.fromCharCode(97 + num - 1).toUpperCase();
      } else return '';
    },
    createTable(col, row, color) {
      if (col && row) {
        let rows = [];
        let table = [];
        for (let r = 0; r < row; r++) {
          rows = [];
          for (let c = 0; c < col; c++) {
            rows.push({ color: 0, actualColor: '#ffffff' });
          }
          table.push(rows);
        }
        this.customCoding.table = table;
      }
      this.customCoding.colors = [];
      for (let co = 0; co < color; co++) {
        this.customCoding.colors.push({ color: '#ffffff', code: '' });
      }
    },
    initDb() {
      this.localDB = new PouchDB('customeCoding', { auto_compaction: true });
      // console.log(localDB);
      this.getAllLocalRoulette();
    },
    getAllLocalRoulette() {
      this.localDB
        .allDocs()
        .then((response) => {
          this.localDbData = response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLocalRoulette(id) {
      this.localDB
        .get(id)
        .then((response) => {
          console.log(response);
          this.customCoding = response.conf;
          this.elementNumber = response.conf.items.length;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearLocalRoulette() {
      this.localDB
        .destroy()
        .then((response) => {
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addCustomRouletteToLocalDb() {
      this.localDB
        .put(
          {
            _id: 'my_coding_' + this.localDbData.rows.length,
            conf: this.customCoding,
          },
          { force: true }
        )
        .then((response) => {
          console.log(response);
          this.getAllLocalRoulette();
        })
        .catch((err) => {
          if (err.name === 'conflict') {
            console.log('conflick');
          }
          console.log(err);
        });
    },
    codingShow() {
      for (let x = 0; x < this.customCoding.table.length; x++) {
        for (let y = 0; y < this.customCoding.table[x].length; y++) {
          if (this.customCoding.table[x][y].actualColor != '#ffffff') {
            if (this.customCoding.colors.some((u) => u.color == this.customCoding.table[x][y].actualColor)) {
              this.customCoding.table[x][y].color =
                this.customCoding.colors.findIndex((u) => u.color == this.customCoding.table[x][y].actualColor) + 1;
            } else {
              this.customCoding.colors.push({ color: this.customCoding.table[x][y].actualColor, code: '' });
              this.customCoding.table[x][y].color =
                this.customCoding.colors.findIndex((u) => u.color == this.customCoding.table[x][y].actualColor) + 1;
            }
          }
        }
      }

      // this.showConfig = false;
      // this.showCoding = true;
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.multibookType);
      let gameObj = {
        item: {
          author: 'MB',
          engine: 'coding',
          avatar: 'OLO',
          gameConfig: this.customCoding,
          title: [{ text: 'Dopasuj kolory' }],
        },
      };
      if (gameObj) {
        this.$store.dispatch('newGame', gameObj);
        this.redirect('game-view');
      }
    },
    redirect(router) {
      this.$router.push({ name: router });
    },
    closeModal() {
      this.$emit('closeCustomCoding');
    },
    setWidthScale() {
      let itm = document.getElementById('mb-custom-coding').getBoundingClientRect();
      console.log(itm);
      return itm.width / 1920;
    },
    setHeightScale() {
      let itm = document.getElementById('mb-custom-coding').getBoundingClientRect();
      console.log(itm);
      return itm.height / 1080;
    },
    resizeWindow(e) {
      let itm = document.getElementById('mb-custom-coding').getBoundingClientRect();
      this.scale = Math.min(itm.width / 1920, itm.height / 1080);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cExitIcon MbCustonCoding- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cExitIconOn MbCustonCoding- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    addIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/add-64px.png`);
      } catch {
        console.log(
          '%cAddIcon MbCustonCoding- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
$break-large: 1400px
#mb-custom-coding
  width: 100%
  position: absolute
  top: 0
  height: 100%
  z-index: 8
  background: #f2f2f2
  .mb-custom-coding-scalable
    width: 1920px
    height: 1080px
    top: 0
    left: 0
    background: #ffd100
    text-align: center
    position: relative
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    transform-origin: center center
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    .local-coding-select
      position: absolute
      top: 0
      left: 0
      background: #f2f2f2
      filter: drop-shadow(10px 10px 10px rgba(0,0,0, .4))
      .local-coding-select-item
        margin: 5px
        padding: 10px 20px
        transition: .5s
        background: #f2f2f2
        cursor: pointer
        font-size: 24px
        &:hover
          background: gray
    .main-container
      width: 80%
      height: 100%
      position: absolute
      top: 0
      left: 0
      display: flex
      justify-content: center
      align-items: center
      .table-container
        box-shadow: 0 0 10px 5px rgba(0,0,0,0.3)
        .row-number
          width: 100px
          height: 100px
          background: darkgray
          margin: 2px
          display: flex
          justify-content: center
          align-items: center
          font-size: 32px
        .row
          background: black
          padding: 0
          .row-item
            margin: 2px
            cursor: pointer
            transition: .5s
            position: relative
            img
              width: 100%
              height: 100%
              position: absolute
              top: 0
              left: 0
              transition: .5s
    .element-adder
      padding: 30px
      max-height: 1050px
      width: 400px
      background: #f2f2f2
      // filter: drop-shadow(10px 10px 10px rgba(0,0,0, .4))
      box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.3)
      // border-radius: 20px
      right: 0
      display: flex
      align-items: center
      flex-direction: column
      justify-content: center
      p
        margin: 10px
        padding: 0

      .element-adder-item
        width: 100%
        text-align: left
        padding: 10px 0px
        display: flex
        align-items: center
        justify-content: flex-start
        .left
          width: 30%
          display: inline-block
        .right
          width: 65%
          display: inline-block
        .right-flex
          width: 65%
          display: flex
          align-items: center
          justify-content: flex-start
        span
          font-size: 24px
          transition: .3s
        .form-group
          position: relative
          padding: 15px 0 0
          margin-top: 10px
          width: 50%
        .form-input
          width: 100%
          border: 0
          border-bottom: 2px solid gray
          outline: 0
          font-size: 24px
          color: black
          // padding: 7px 0
          background: transparent
          transition: border-color 0.2s
        .form-input:focus
          padding-bottom: 6px
          border-width: 3px
          border-image: linear-gradient(to right, #ffd100, #ffd100)
          border-image-slice: 1
      .icon-container
        display: flex
        align-items: center
        flex-direction: row
        justify-content: space-between
  .icon-container-small
    display: inline-block
    position: absolute
    top: 40px
    right: 30px
    width: 48px
    height: 48px

    .controll-icon, .controll-icon-small
      position: absolute
      top: 0
      left: 0
      width: 48px
      height: 48px
      transition: .5s
      // transform: scale(.9)
      cursor: pointer
    .controll-icon-small
      width: 32px
      height: 32px
      margin-top: -15px
      margin-left: 20px

@keyframes iconShow
  0%
    opacity: 0
    transform: rotate(-25deg) scale(.9)
  50%
    opacity: 1
    transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
